import * as React from "react";
import { SelectInput, Button, required, useDataProvider, SelectArrayInput } from "react-admin";
import { Container, Grid, Paper } from "@material-ui/core";
import { Form } from "react-final-form";
import SearchIcon from "@material-ui/icons/Search";
import { useState } from "react";
import { CustomDatetime } from "../../../Components/CustomDatetime";
import { useAuth } from "@airborne/react-admin";
import appDataProvider from "../../../dataprovider";
import { Add } from "@material-ui/icons";
import { ReliabilityReportType } from "../../../Enums/ReliabilityReportType";
import ReliabilityManualPoolCreate from "../ManualCreate/ReliabilityManualPoolCreate";

const FailOnFitFilter = ({ filterParams, setFilterParams }: any) => {
  const { user } = useAuth();
  const dataProvider = useDataProvider();

  const [ownerCodeList, setOwnerCodeList] = useState<any>([]);
  const [fleetTypes, setFleetTypes] = useState<any>([]);
  const [acTypes, setAcTypes] = useState<any>([]);
  const [createOpen, setCreateOpen] = useState<boolean>(false);

  React.useEffect(() => {
    GetOwnerCodeList();
    GetFleetTypes();
    GetAcTypes();
  }, []);

  const GetOwnerCodeList = () => {
    dataProvider
      .getList("customers", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "customerName", order: "ASC" },
        filter: { isActive__eq: true },
      })
      .then(response => {
        const ownerCodes = [
          ...new Set(
            response?.data?.map(item => {
              return { ownerCode: item.ownerCode, customerName: item.customerName };
            })
          ),
        ];
        setOwnerCodeList(ownerCodes);
      })
      .catch(error => {
        console.log(error);
      });
  };
  const GetFleetTypes = () => {
    appDataProvider.http
      .get("cdmaircraft/FetchFleetTypes")
      .then(response => {
        setFleetTypes([...(response?.data?.items ?? [])]);
      })
      .catch(error => {
        console.log(error);
      });
  };
  const GetAcTypes = () => {
    appDataProvider.http
      .get("cdmaircraft/FetchAcTypes")
      .then(response => {
        setAcTypes([...(response?.data?.items ?? [])]);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const onSubmit = values => {
    setFilterParams(values);
  };
  const onCloseCreate = () => {
    setCreateOpen(false);
  };
  const onOpenCreate = e => {
    setCreateOpen(true);
  };
  return (
    <Container maxWidth="xl">
      <ReliabilityManualPoolCreate
        isOpen={createOpen}
        onClose={onCloseCreate}
        reportType={ReliabilityReportType.FailOnFit}
      />
      <Form
        onSubmit={onSubmit}
        initialValues={filterParams}
        render={({ handleSubmit, form, submitting, pristine, values }) => (
          <form onSubmit={handleSubmit} noValidate>
            <Paper style={{ padding: 10 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  {!user?.isCustomer && (
                    <SelectArrayInput
                      source="ownerCode"
                      optionValue="ownerCode"
                      optionText="customerName"
                      fullWidth
                      variant="outlined"
                      choices={ownerCodeList}
                      label="Customer"
                      disabled={user?.isCustomer}
                      allowEmpty
                    />
                  )}
                  <CustomDatetime
                    source="startDate"
                    fullWidth
                    variant="outlined"
                    label="Start Date"
                    validate={required()}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  {!user?.isCustomer && (
                    <SelectInput
                      source="acType"
                      optionValue="acType"
                      optionText="acType"
                      fullWidth
                      variant="outlined"
                      choices={acTypes}
                      label="Ac Type"
                      allowEmpty
                    />
                  )}
                  <CustomDatetime
                    source="endDate"
                    fullWidth
                    variant="outlined"
                    label="End Date"
                    validate={required()}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  {!user?.isCustomer && (
                    <SelectInput
                      source="fleetType"
                      optionValue="text"
                      optionText="text"
                      fullWidth
                      variant="outlined"
                      choices={fleetTypes}
                      disabled={user?.isCustomer}
                      label="Fleet Type"
                      allowEmpty
                    />
                  )}
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={submitting}
                    label="Search"
                    size="large"
                    startIcon={<SearchIcon />}
                    style={{ marginTop: 6 }}
                  />
                  <Button
                    onClick={onOpenCreate}
                    variant="contained"
                    color="primary"
                    disabled={submitting}
                    label="Create"
                    size="large"
                    startIcon={<Add />}
                    style={{ marginTop: 6, marginLeft: 5 }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </form>
        )}
      />
    </Container>
  );
};

export default FailOnFitFilter;
